//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { date } from 'quasar'
import { inputMaskProcessor } from './InputMaskProcessor.js'
import DateTimePicker from './DateTimePicker.vue'

export default {
  name: 'DateTimeField',
  components: {
    DateTimePicker
  },
  mixins: [inputMaskProcessor],
  props: {
    label: {
      type: String,
      required: true
    },
    value: {
      type: [String, Number],
      default: null
    },
    defaultValue: {
      type: Number,
      default: null
    },
    modelType: {
      type: String,
      default: 'text' // text, millis
    },
    readonly: {
      type: Boolean,
      default: false
    },
    disableInput: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: false
    },
    labelColor: {
      type: String,
      default: 'black'
    },
    placeholder: {
      type: String,
      default: null
    },
    iconTooltip: {
      type: String,
      default: null
    },
    dense: {
      type: Boolean,
      default: false
    },
    rules: {
      type: Array,
      default: undefined
    },
    format: {
      type: String,
      default: null
    },
    debounce: {
      type: Number,
      default: 0
    },
    optionsDate: {
      type: Function,
      default: () => true
    },
    optionsTime: {
      type: Function,
      default: () => true
    },
    minuteOptions: {
      type: Array,
      default: () => undefined
    },
    withSeconds: {
      type: Boolean,
      default: false
    },
    hideNowBtn: {
      type: Boolean,
      default: false
    },
    confirmBtns: {
      type: Boolean,
      default: true // TODO продумать, как сделать иначе. Например, делать последовательную фокусировку на полях времени, а при клике на последнее (минуты или секунды) закрывать попап и применять значение
    }
  },
  data: function () {
    return {
      popupActive: false,
      matchFormat: true,

      textValue: '',
      pickerTextValue: ''
    }
  },
  computed: {
    formatConfig: function () {
      let format = this.format
      let withSeconds = this.withSeconds
      if (!format) {
        format = withSeconds ? 'DD.MM.YYYY HH:mm:ss' : 'DD.MM.YYYY HH:mm'
      } else {
        withSeconds = !!format.includes('ss')
      }

      const mask = format.replaceAll(/[a-z]/gi, '#')
      const maskPatternArray = ['^']
      for (const ch of mask.split('')) {
        if (ch === '#') {
          maskPatternArray.push('\\d')
        } else if (ch === '.') {
          maskPatternArray.push('\\.')
        } else {
          maskPatternArray.push(ch)
        }
      }
      maskPatternArray.push('$')
      const maskRegExp = new RegExp(maskPatternArray.join(''))

      const formatConfig = {
        format,
        withSeconds,
        mask,
        maskRegExp
      }

      let formatPlaceholder = format
      formatConfig.seconds = format.includes('ss')
      if (formatConfig.seconds) {
        formatPlaceholder = formatPlaceholder.replaceAll('ss', 'cc')
      }
      formatConfig.minutes = format.includes('mm')
      if (formatConfig.minutes) {
        formatPlaceholder = formatPlaceholder.replaceAll('mm', 'мм')
      }
      formatConfig.hours = format.includes('HH')
      if (formatConfig.hours) {
        formatPlaceholder = formatPlaceholder.replaceAll('HH', 'чч')
      }
      formatConfig.date = format.includes('DD')
      if (formatConfig.date) {
        formatPlaceholder = formatPlaceholder.replaceAll('DD', 'дд')
      }
      formatConfig.month = format.includes('MM')
      if (formatConfig.month) {
        formatPlaceholder = formatPlaceholder.replaceAll('MM', 'мм')
      }
      formatConfig.year = format.includes('YY')
      if (formatConfig.year) {
        formatPlaceholder = formatPlaceholder.replaceAll('YY', 'гг')
      }
      formatConfig.placeholder = formatPlaceholder

      formatConfig.onlyDate = !formatConfig.hours && !formatConfig.hours && !formatConfig.seconds

      return formatConfig
    },
    placeholderLocal: function () {
      if (this.placeholder != null) {
        return this.placeholder
      } else if (this.formatConfig.placeholder) {
        return this.formatConfig.placeholder
      }
      return null
    },
    rulesLocal: function () {
      const rules = []
      rules.push(() => this.matchFormat)
      if (this.rules && rules.length) {
        rules.push(...this.rules)
      }
      return rules
    },
    hasError: function () {
      return !!this.$refs.field && this.$refs.field.hasError
    },
    empty: function () {
      return this.textValue == null || this.textValue === ''
    }
  },
  watch: {
    value: {
      handler: function (value) {
        this.textValue = this.formatValue(value)
      },
      immediate: true
    }
  },
  mounted: function () {
    this.applyInputMaskProcessor('field')
  },
  methods: {
    formatValue: function (value) {
      if (this.modelType === 'millis') {
        return this.formatMillis(value) || ''
      }
      return value || ''
    },
    formatMillis: function (millis) {
      if (millis) {
        return date.formatDate(millis, this.formatConfig.format)
      }
      return null
    },
    parseDate (value) {
      return date.extractDate(value, this.formatConfig.format)
    },
    parseMillis (value) {
      return this.parseDate(value).getTime()
    },

    // ===

    onInput: function (textValue) {
      this.setValue(textValue)
    },
    setValue: function (textValue) {
      let value
      if (this.modelType === 'millis') {
        if (textValue) {
          const matchResult = textValue.match(this.formatConfig.maskRegExp)
          if (!matchResult) {
            this.setMatchFormat(false)
            return
          }

          value = this.parseMillis(textValue)
        } else {
          value = null
        }
      } else {
        value = textValue
      }

      this.emitValue(value)
    },

    // Picker ===

    onIconClick: function () {
      if (this.readonly) {
        return
      }

      this.popupActive = true
      this.$nextTick(() => {
        this.$nextTick(() => {
          this.$refs.timePicker.show()

          if (this.defaultValue && !this.value) {
            const defaultTextValue = this.formatMillis(this.defaultValue)
            if (!this.confirmBtns) {
              this.textValue = defaultTextValue
              this.onInput(this.textValue)
            }

            this.pickerTextValue = defaultTextValue
          } else {
            this.pickerTextValue = this.textValue
          }
        })
      })
    },
    onPickerDateChange: function (pickerTextValue) {
    },
    onPickerInput: function (pickerTextValue) {
      if (!this.confirmBtns && this.formatConfig.onlyDate) {
        this.onPickerConfirm(pickerTextValue)
      }
    },
    onPickerConfirm: function (pickerTextValue) {
      this.setValue(pickerTextValue)
      this.onPickerCancel()
    },
    onPickerCancel: function () {
      if (this.$refs.timePicker) {
        this.$refs.timePicker.hide()
      }

      this.$nextTick(() => {
        this.popupActive = false
      })
    },
    onPickerHidden: function (e) {
      this.$nextTick(() => {
        if (this.popupActive) {
          this.popupActive = false
        }
      })
    },

    // ===

    onBlur: function () {
      if (!this.matchFormat) {
        this.textValue = this.formatValue(this.value) // reset value
        this.$refs.field.innerValue = this.textValue
        this.setMatchFormat(true)
      }

      this.$emit('blur')
    },
    onFieldClick: function () {
      if (this.disableInput) {
        this.onIconClick()
      }
    },
    onClear: function () {
      if (this.readonly) {
        return
      }

      this.emitValue(null)
      this.$emit('clear')
    },
    emitValue: function (value = null) {
      this.setMatchFormat(true)
      this.$emit('input', value)
    },
    setMatchFormat: function (matchFormat) {
      if (this.matchFormat != matchFormat) {
        this.matchFormat = matchFormat
        this.validate()
      }
    },
    validate: function () {
      return this.$refs.field.validate()
    }
  }
}
